module.exports = __webpack_public_path__ + "img/alertCircle.fd0ba06e.svg";